import { Col, Container, Row, Typography } from 'darrius';

import { type TPromotionProps } from '../@interfaces';

import styles from './Promotion.module.scss';

export const Promotion = ({ descriptions, title }: TPromotionProps) => {
  return (
    <Container className={styles['signup-mgm__promotion']}>
      <Row
        className={`${styles['signup-mgm__promotion__title']} center-sm space-bottom`}
      >
        <Col className="col-sm-12">
          <Typography.Title size="3xl">{title}</Typography.Title>
        </Col>
      </Row>

      <Row className="center-sm space-bottom">
        <Col className="col-md-8 col-sm-12">
          {descriptions.map((text) => (
            <div
              key={text}
              className={styles['signup-mgm__promotion__description']}
            >
              <img
                src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/check-green.svg`}
                alt="Icone de comunicação"
              />
              <span>{text}</span>
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  );
};
